import { payloadAction } from "utils/stateUtils";
export const DOWNLOAD_REPORT = "DOWNLOAD_REPORT";
export const DOWNLOAD_REPORT2 = "DOWNLOAD_REPORT2";
export const REPORTS_SET_PROPS = "REPORTS_SET_PROPS";


export const downloadReport = payloadAction(DOWNLOAD_REPORT);
export const downloadReport2 = payloadAction(DOWNLOAD_REPORT2);
export const setReportProps = payloadAction(REPORTS_SET_PROPS);
